export const routes = {
    path: 'parceiropj',
    name: 'NAN_Parceiro_PJ',
    component: () => import('./AlterarPj.vue'),
    meta: {
        rules: [],
    },
    children: [
    ],
};